<script setup lang="ts">
import { useValidationState } from "@/state/validationState";
import { useAIState } from "@/state/aiState";
import { useUserState } from "@/state/userState";
import { useConfigState } from "@/state/configState";
import { useMethodState } from "@/state/methodState";
import { useExportProtocol } from "@/state/run/useExportProtocol";
import { useDeckLayoutState } from "@/state/run/useDeckLayoutState";

const validationState = useValidationState();
const aiState = useAIState();
const userState = useUserState();
const configState = useConfigState();
const methodState = useMethodState();
const exportProtocolState = useExportProtocol();
const deckLayoutState = useDeckLayoutState();

// Expose state on window for e2e interactive sessions (dev-only component)
if (window.location.hostname === "localhost") {
  (window as any).__e2e_state = {
    method: methodState,
    config: configState,
    validation: validationState,
    ai: aiState,
    user: userState,
    exportProtocol: exportProtocolState,
    deckLayout: deckLayoutState,
  };
}
</script>

<template>
  <!-- Empty template - this component is just for debugging -->
</template>
